(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-the-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-back-to-top]');

    if (!button || button.dataset.initialized === 'true') return;

    button.dataset.initialized = 'true';

    let lastScrollTop = Math.max(window.scrollY, 0);
    let ticking = false;

    const setVisibility = (visible) => {
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', String(!visible));
      button.setAttribute('tabindex', visible ? '0' : '-1');
    };

    const updateButton = () => {
      const currentScroll = Math.max(window.scrollY, 0);
      const difference = currentScroll - lastScrollTop;

      if (currentScroll <= 200) {
        setVisibility(false);
      } else if (Math.abs(difference) > 5) {
        setVisibility(difference < 0);
        lastScrollTop = currentScroll;
      }

      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(updateButton);
      },
      { passive: true }
    );

    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["seel-auto-remove"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;

  const isCoverage = (item) => {
    const vendor = String(item.vendor || '').trim().toLowerCase();
    const title = String(item.product_title || item.title || '').toLowerCase();
    return vendor === 'seel' || title.includes('worry-free purchase');
  };

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  };

  const updateCart = async (updates) => {
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    });

    if (!response.ok) throw new Error('Unable to update cart');
  };

  const removeOrphanCoverage = async () => {
    if (busy) return;
    busy = true;

    try {
      const cart = await getCart();
      const coverageItems = cart.items.filter(isCoverage);
      const qualifyingItems = cart.items.filter((item) => !isCoverage(item));

      if (coverageItems.length === 0 || qualifyingItems.length > 0) return;

      const updates = {};
      coverageItems.forEach((item) => {
        updates[item.key] = 0;
      });

      await updateCart(updates);
      window.location.reload();
    } finally {
      busy = false;
    }
  };

  const findTargetItem = (cart, link) => {
    const url = new URL(link.href, window.location.origin);
    const line = Number(url.searchParams.get('line'));
    const id = url.searchParams.get('id');

    if (line > 0) return cart.items[line - 1];
    if (!id) return null;

    return cart.items.find((item) => {
      return item.key === id || String(item.variant_id) === id;
    });
  };

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[href*="/cart/change"]');
    if (!link) return;

    const url = new URL(link.href, window.location.origin);
    if (url.searchParams.get('quantity') !== '0') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (busy) return;
    busy = true;

    try {
      const cart = await getCart();
      const targetItem = findTargetItem(cart, link);

      if (!targetItem) {
        window.location.assign(link.href);
        return;
      }

      const coverageItems = cart.items.filter(isCoverage);
      const qualifyingItems = cart.items.filter((item) => !isCoverage(item));
      const updates = { [targetItem.key]: 0 };

      if (!isCoverage(targetItem) && qualifyingItems.length === 1) {
        coverageItems.forEach((item) => {
          updates[item.key] = 0;
        });
      }

      await updateCart(updates);
      window.location.reload();
    } catch {
      window.location.assign(link.href);
    }
  }, true);

  window.addEventListener('pageshow', removeOrphanCoverage);
})();
  } catch(e) { console.error(e); }
})();

})();
